import { FC } from 'react';

import { FrequencyManagementPage } from 'modules/frequencyManagement/components/layout/FrequencyManagementPage';
import { ModalContextProvider } from 'utils/contexts/modal';
import { CoreProvider } from 'modules/frequencyManagement/contexts/CoreProvider';
import { useSelectedMedium } from 'modules/frequencyManagement/hooks/useSelectedMedium';

export const FrequencyManagementIndex: FC = () => {
  const selectedMedium = useSelectedMedium();

  return (
    <CoreProvider>
      <ModalContextProvider>
        <FrequencyManagementPage messageMedium={selectedMedium} />
      </ModalContextProvider>
    </CoreProvider>
  );
};
